import { render, staticRenderFns } from "./MassenmutationButton.vue?vue&type=template&id=5d47b4d8&"
import script from "./MassenmutationButton.vue?vue&type=script&lang=js&"
export * from "./MassenmutationButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports